module.exports = __webpack_public_path__ + "static/img/ban_bgs.3673dc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ban_bgs.png
// module id = 1BUM
// module chunks = 1